import React from 'react';
import PropTypes from 'prop-types';

export default function Day({
  props, currentDate, selectedDay, setSelectedDay, setFullSelectedDay, setSelectedTime,
}) {
  /* eslint-disable react/prop-types */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  /* eslint-disable react/jsx-props-no-spreading */
  const month = (props['data-month'] + 1).toString();
  const day = props['data-value'];

  const isDisabled = props.className.includes('rdtDisabled');

  const onChooseDay = () => {
    if (isDisabled) {
      return;
    }
    setSelectedDay(`${month}.${day}`);
    setFullSelectedDay(currentDate.toDate());
    setSelectedTime(null);
  };

  return (
    <td
      {...props}
      className={`${props.className} ${selectedDay === `${month}.${day}` ? 'selected' : ''}`}
      onClick={onChooseDay}
    >
      <span>{currentDate.date()}</span>
    </td>
  );
}

Day.propTypes = {
  props: PropTypes.object.isRequired,
  currentDate: PropTypes.instanceOf(Date).isRequired,
  selectedDay: PropTypes.string,
  setSelectedDay: PropTypes.func.isRequired,
  setFullSelectedDay: PropTypes.func.isRequired,
  setSelectedTime: PropTypes.func.isRequired,
};

Day.defaultProps = {
  selectedDay: null,
};
